import React from "react"
import PropTypes from "prop-types"
import Moment from "moment"

// D3
import { scaleBand, scaleLinear, scaleTime } from "d3-scale"
import { max, min } from "d3-array"

// Components
import LineChartViz from "./LineChartViz"

const LineChart = props => {
  // Props
  const { labels, containerWidth, lineDataLabels } = props

  // Dimensions
  const svgWidth = containerWidth
  const svgHeight = containerWidth / 3
  const margin = {
    top: svgHeight * 0.03,
    bottom: svgHeight * 0.3,
    left: 45,
    right: 10
  }
  const w = svgWidth - margin.left - margin.right
  const h = svgHeight - margin.top - margin.bottom

  if (lineDataLabels) {
    // Scales
    const labelXScale = scaleBand()
      .domain(labels)
      .rangeRound([0, w])
      .paddingInner(0.5)
    const lineXScale = scaleTime()
      .domain([
        min(lineDataLabels, d => Moment(d.month, "MMYYYY").toDate()),
        max(lineDataLabels, d => Moment(d.month, "MMYYYY").toDate())
      ])
      .range([0, w - labelXScale.bandwidth()])
    const lineYScale = scaleLinear()
      .domain([0, 100])
      .range([h, 0])

    // Viz Props
    const vizProps = {
      w,
      h,
      labelXScale,
      lineXScale,
      lineYScale,
      svgWidth,
      svgHeight,
      margin,
      ...props
    }

    return <LineChartViz {...vizProps} />
  }
  return null
}

export default LineChart

LineChart.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  containerWidth: PropTypes.number.isRequired,
  lineDataLabels: PropTypes.arrayOf(
    PropTypes.shape({
      month: PropTypes.object,
      score: PropTypes.number
    })
  ).isRequired
}
